export const COUNTY_AREAS = {
  Nairobi: [
    'CBD',
    'Westlands',
    'Kilimani',
    'Karen',
    'Eastleigh',
    'Kasarani',
    'Embakasi',
    'Ruaraka',
    'Rongai',
    'Ruaka',
    'South B',
    'South C',
    'Parklands',
    'Ngong Road',
    'Gigiri',
    'Lavington',
    'Donholm',
    'Umoja',
    'Kahawa',
    'Langata',
    'Kibera',
    'Dagoretti',
    'Muthaiga',
    'Runda',
    'Kileleshwa',
    'Kitisuru',
    'Spring Valley',
    'Brookside',
    'Highridge',
    'Pangani',
    'Jericho',
    'Makadara',
    'Kamukunji',
    'Mathare',
    'Hurlingham',
    'Adams Arcade',
    'Nairobi South',
    'Syokimau Nairobi side',
    'Athi River Nairobi side',
    'Kuwinda',
    'Nyayo Estate',
    'Fedha Estate',
    'Tassia',
    'Pipeline',
    'Kayole',
    'Komarock',
    'Dandora',
    'Kariobangi',
    'Githurai 44',
    'Githurai 45',
    'Zimmerman',
    'Roysambu',
    'Githunguri Road',
    'Waiyaki Way',
    'Lower Kabete',
    'Upper Kabete',
    'Kangemi',
    'Kawangware',
    'Uthiru',
    'Riruta',
    'Karen Blixen',
    'Ngong Hills Nairobi side',
    'Other',
  ],
  Mombasa: [
    'Mombasa Island',
    'Nyali',
    'Bamburi',
    'Likoni',
    'Changamwe',
    'Kisauni',
    'Shanzu',
    'Mtwapa',
    'Mkomani',
    'Mwandoni',
    'Magongo',
    'Jomvu',
    'Mikindani',
    'Tudor',
    'Kongowea',
    'Maweni',
    'Kizingo',
    'Mombasa Road',
    'Port Reitz',
    'Baricho',
    'Shimanzi',
    'Ganjoni',
    'Timbwani',
    'Bombolulu',
    'Mjambere',
    'Mtopanga',
    'Kwa Jomvu',
    'Miritini',
    'Other',
  ],
  Kisumu: [
    'Kisumu Central',
    'Milimani',
    'Nyalenda',
    'Manyatta',
    'Mamboleo',
    'Kondele',
    'Kibuye',
    'Seme',
    'Kajulu',
    'Rusinga',
    'Kisian',
    'Otonglo',
    'Riat',
    'Korando',
    'Lakeside',
    'Railways',
    'Industrial Area',
    'Kolwa',
    'Maseno Kisumu side',
    'Ahero',
    'Miwani',
    'Chemelil',
    'Koguta',
    'Awasi',
    'Katito',
    'Ombeyi',
    'Kopiyo',
    'Kowuor',
    'Other',
  ],
  Nakuru: [
    'Nakuru Town',
    'Section 58',
    'Lanet',
    'Naivasha',
    'Gilgil',
    'Nakuru West',
    'Nakuru East',
    'Milimani Estate',
    'Kaptembwa',
    'Kivumbini',
    'Katiba',
    'Ngata',
    'Baruti',
    'Mwariki',
    'London Estate',
    'Racecourse',
    'Freehold',
    'Rongai Nakuru side',
    'Sobea',
    'Ponda Mali',
    'Kiamunyi',
    'Kihingo',
    'Menengai',
    'Karatina Road',
    'Njoro Nakuru side',
    'Molo Nakuru side',
    'Elburgon',
    'Mau Narok',
    'Salgaa',
    'Bahati',
    'Kabatini',
    'Dundori',
    'Olenguruone',
    'Other',
  ],
  Kiambu: [
    'Thika',
    'Ruiru',
    'Kiambu Town',
    'Juja',
    'Limuru',
    'Kikuyu',
    'Githurai',
    'Kahawa Kiambu side',
    'Kinoo',
    'Wangige',
    'Gitaru',
    'Runda Kiambu side',
    'Tigoni',
    'Kabete Kiambu side',
    'Ndenderu',
    'Muchatha',
    'Kasarani Kiambu side',
    'Githunguri',
    'Karuri',
    'Ndeiya',
    'Lari',
    'Kijabe',
    'Kunyu',
    'Gatundu',
    'Gatundu South',
    'Gatundu North',
    'Kiamwangi',
    'Muguga',
    'Uthiru Kiambu side',
    'Karura',
    'Ndumberi',
    'Riabai',
    'Githiga',
    'Gitwe',
    'Other',
  ],
  Machakos: [
    'Machakos Town',
    'Athi River',
    'Syokimau',
    'Mlolongo',
    'Kathiani',
    'Mavoko',
    'Tala',
    'Kangundo',
    'Matuu',
    'Kakuyuni',
    'Kalama',
    'Kivani',
    'Kyua',
    'Mbiuni',
    'Kola',
    'Yatta',
    'Ikombe',
    'Kaseve',
    'Kithimani',
    'Mutituni',
    'Kinanie',
    'Ongata Rongai Machakos side',
    'Kitengela Machakos side',
    'Muitini',
    'Wamunyu',
    'Mavoloni',
    'Kisukoni',
    'Kithyoko',
    'Mumbuni',
    'Katangi',
    'Kwa Mwatu',
    'Other',
  ],
  Kajiado: [
    'Kitengela',
    'Ngong',
    'Ongata Rongai',
    'Kajiado Town',
    'Kiserian',
    'Isinya',
    'Bissil',
    'Rongai Kajiado side',
    'Namanga',
    'Mashuru',
    'Kenya-ata',
    'Kuku',
    'Oloitoktok',
    'Entonet',
    'Ewuaso',
    'Ntashata',
    'Ilbisil',
    'Imbirikani',
    'Rombo',
    'Taveta Kajiado side',
    'Kimana',
    'Kajiado Central',
    'Magadi',
    'Lake Natron area',
    'Nairobi National Park area',
    'Oloolua',
    'Mbirikani',
    'Lemelok',
    'Other',
  ],
  'Uasin Gishu': [
    'Eldoret Town',
    'Langas',
    'Pioneer',
    'Kapsoya',
    'Kipkenyo',
    'Kamagut',
    'Moi University area',
    'Kesses',
    'Ngeria',
    'Chebisaas',
    'Sergoit',
    'Kimumu',
    'Simat',
    'Kapteren',
    'Lelmokwo',
    'Lessos',
    'Kaptagat',
    'Burnt Forest',
    'Turbo',
    'Munyaka',
    'Kakamega Road',
    'Kitale Road',
    'Kipkaren',
    'Kibabet',
    'Soy',
    'Kuywa',
    'Kipkeino',
    'Kaptabuk',
    'Kiplombe',
    'Other',
  ],
  Kilifi: [
    'Kilifi Town',
    'Malindi',
    'Watamu',
    'Mtwapa Kilifi side',
    'Kikambala',
    'Kanamai',
    'Shanzu Kilifi side',
    'Bamburi Kilifi side',
    'Dabaso',
    'Nyangoro',
    'Mariakani Kilifi side',
    'Kaloleni',
    'Matsangoni',
    'Magarini',
    'Gede',
    'Mambrui',
    'Marafa',
    'Kilifi Creek',
    'Rabai',
    'Bomani',
    'Chembe',
    'Takaungu',
    'Jaribuni',
    'Kakuyuni Kilifi side',
    'Chonyi',
    'Kauma',
    'Kawala',
    'Kizurini',
    'Mtepeni',
    'Other',
  ],
  Kwale: [
    'Diani',
    'Ukunda',
    'Msambweni',
    'Kwale Town',
    'Lunga Lunga',
    'Vanga',
    'Shimoni',
    'Galu',
    'Kinondo',
    'Tiwi',
    'Mvuleni',
    'Kikoneni',
    'Kubwa',
    'Mafisini',
    'Mkwiro',
    'Wasini',
    'Mivumoni',
    'Dzombo',
    'Kingwede',
    'Kidimu',
    'Waa',
    'Kombani',
    'Mata',
    'Maghreb',
    'Mwachande',
    'Mkanda',
    'Mgeni',
    'Other',
  ],
  Nyeri: [
    'Nyeri Town',
    'Karatina',
    'Othaya',
    'Mukurwe-ini',
    'Mwea Nyeri side',
    'Tetu',
    'Kiganjo',
    'Naro Moru',
    'Mweiga',
    'Gatundu Nyeri side',
    'Mathira',
    'Iriaini',
    'Ruguru',
    'Kiamuturi',
    'Chaka',
    'Nyahururu Nyeri side',
    'Ol Kalou Nyeri side',
    'Kihuri',
    'Kangaita',
    'Mugunda',
    'Theta',
    'Kamakwa',
    'Thegu',
    'Gakindu',
    'Gathukiini',
    'Other',
  ],
  Meru: [
    'Meru Town',
    'Maua',
    'Nkubu',
    'Timau',
    'Githongo',
    'Nchiru',
    'Kianjai',
    'Kanyakine',
    'Muthara',
    'Igonji',
    'Mitunguu',
    'Mikumbune',
    'Mbeu',
    'Kanuni',
    'Mwituria',
    'Kithoka',
    'Kiirua',
    'Nkandone',
    'Ruiga',
    'Akirangondu',
    'Kariene',
    'Kianjiru',
    'Kiorimba',
    'Kianjokoma Meru side',
    'Mikinduri',
    'Athi',
    'Other',
  ],
  Kakamega: [
    'Kakamega Town',
    'Mumias',
    'Butere',
    'Shinyalu',
    'Lugari',
    'Malava',
    'Mwisikhana',
    'Shikoti',
    'Mukumu',
    'Kisumu Road',
    'Kakamega Forest',
    'Kocholia',
    'Isukha',
    'Idakho',
    'Kisa',
    'Khwisero',
    'Koyonzo',
    'Mukuyu',
    'Shirere',
    'Lukume',
    'Mureko',
    'Kakunga',
    'Navakholo',
    'Musanda',
    'Shianda',
    'Mumias East',
    'Mumias West',
    'Other',
  ],
  Bungoma: [
    'Bungoma Town',
    'Webuye',
    'Kimilili',
    'Sirisia',
    'Kanduyi',
    'Tongaren',
    'Bumula',
    'Malakisi',
    'Kimaeti',
    'Naitiri',
    'Maiuya',
    'Kibabii',
    'Siritanyi',
    'Chwele',
    'Kamukuywa',
    'Mukuyuni',
    'Kakamari',
    'Lwanda',
    'Khasoko',
    'Sango',
    'Misikhu',
    'Kibisi',
    'Kaptama',
    'Other',
  ],
  Kisii: [
    'Kisii Town',
    'Nyamache',
    'Ogembo',
    'Kenyerere',
    'Keumbu',
    'Marani',
    'Sotik Kisii side',
    'Keroka',
    'Mokwerero',
    'Gucha',
    'Ekerenyo',
    'Kitutu',
    'Nyanchwa',
    'Riana',
    'Manga',
    'Matongo',
    'Sameta',
    'Tendere',
    'Bonyamatuta',
    'Nyakoe',
    'Suneka',
    'Mosocho',
    'Nyangusu',
    'Ikobe',
    'Kegogi',
    'Kiamokama',
    'Other',
  ],
  Migori: [
    'Migori Town',
    'Rongo',
    'Awendo',
    'Suna',
    'Kuria',
    'Kehancha',
    'Sori',
    'Masara',
    'Kakrao',
    'Nyatike',
    'Macalder',
    'Konyango',
    'Kachieng',
    'Koyieng',
    'Uriri',
    'Kokwanyo',
    'Sare',
    'Kawere',
    'Onyancha',
    'Rakwaro',
    'Kadika',
    'Kuja',
    'Other',
  ],
  'Homa Bay': [
    'Homa Bay Town',
    'Mbita',
    'Oyugis',
    'Kendu Bay',
    'Sindo',
    'Rod Kopany',
    'Rachuonyo',
    'Kosele',
    'Gandhi Beach',
    'Rusinga Island',
    'Mfangano Island',
    'Nyandiwa',
    'Kokwot',
    'Kadianga',
    'Kanyaluo',
    'Lambwe',
    'Rangwe',
    'Kobier',
    'Kamasengre',
    'Othoro Homa Bay side',
    'Other',
  ],
  Siaya: [
    'Siaya Town',
    'Bondo',
    'Yala',
    'Ukwala',
    'Alego',
    'Gem',
    'Rangala',
    'Ng\'iya',
    'Bar Olengo',
    'Ndanai',
    'Sega',
    'Lwak',
    'Muhuru',
    'Nyamninia',
    'Othoro',
    'Kombewa',
    'Usonga',
    'Ugunja',
    'Kogelo',
    'Sidindi',
    'Kajola',
    'Other',
  ],
  Busia: [
    'Busia Town',
    'Malaba',
    'Matayos',
    'Nambale',
    'Butula',
    'Funyula',
    'Bumala',
    'Budalangi',
    'Port Victoria',
    'Sio Port',
    'Ageng\'a',
    'Kisoko',
    'Rwambwa',
    'Busiende',
    'Kochia',
    'Mundika',
    'Odiado',
    'Marenga',
    'Other',
  ],
  Vihiga: [
    'Mbale',
    'Vihiga Town',
    'Sabatia',
    'Emuhaya',
    'Luanda',
    'Kaimosi',
    'Wodanga',
    'Mudasa',
    'Chavakali',
    'Mumboha',
    'Tiriki',
    'Maragoli Hills',
    'Lugaga',
    'Kwagwe',
    'Muhudu',
    'Kaptega',
    'Other',
  ],
  Embu: [
    'Embu Town',
    'Runyenjes',
    'Manyatta',
    'Kiritiri',
    'Siakago',
    'Kianjokoma',
    'Kithimu',
    'Nthagaiya',
    'Ngandori',
    'Kevote',
    'Karurumo',
    'Gachoka',
    'Kigumo Embu side',
    'Mwea Embu side',
    'Itabua',
    'Riamukurwe',
    'Kieni',
    'Mukuuri',
    'Other',
  ],
  Kirinyaga: [
    'Kerugoya',
    'Kutus',
    'Baricho',
    'Sagana',
    'Kimbimbi',
    'Mwea Kirinyaga side',
    'Wanguru',
    'Thiba',
    'Ndia',
    'Gichugu',
    'Kianyaga',
    'Githambo',
    'Mutithi',
    'Kiandieri',
    'Kibingoti',
    'Kiangai',
    'Kangaita Kirinyaga side',
    'Other',
  ],
  "Murang'a": [
    "Murang'a Town",
    'Kangema',
    'Kigumo',
    'Kenol',
    'Makuyu',
    'Maragua',
    'Kandara',
    'Gatanga',
    'Kahuro',
    'Kiriaini',
    'Ndunyu Njeru',
    'Kakuzi',
    'Muriuki',
    'Kiruri',
    'Tuthu',
    'Gathanga',
    'Muthithi',
    'Ngararia',
    'Kihumbuini',
    'Kanyenyaini',
    'Other',
  ],
  Nyandarua: [
    'Ol Kalou',
    'Nyahururu',
    'Kinangop',
    'Kipipiri',
    'Ndaragwa',
    'Engineer',
    'Miharati',
    'Gathanji',
    'Magumu',
    'Weru',
    'Njabini',
    'Turasha',
    'Kaimbaga',
    'Kipkurere',
    'Mwenje',
    'Githabai',
    'Kanunga',
    'Samburu Nyandarua side',
    'Other',
  ],
  Nandi: [
    'Kapsabet',
    'Nandi Hills',
    'Tinderet',
    'Aldai',
    'Chesumei',
    'Mosoriot',
    'Kilibwoni',
    'Kabiyet',
    'Kipkaren Nandi side',
    'Baraton',
    'Kaptumo',
    'Kosirai',
    'Kipchoge',
    'Kemeloi',
    'Chemundu',
    'Kobujoi',
    'Kiptarus',
    'Chepterit',
    'Kipkaboi',
    'Other',
  ],
  Kericho: [
    'Kericho Town',
    'Litein',
    'Kipkelion',
    'Bomet Kericho side',
    'Sotik Kericho side',
    'Kapsuser',
    'Sigowet',
    'Soin',
    'Kenyengwa',
    'Kapkatet',
    'Tebesonik',
    'Seretut',
    'Kapselek',
    'Kisii Kericho side',
    'Cheborge',
    'Mogogosiek',
    'Kapsaos',
    'Other',
  ],
  Bomet: [
    'Bomet Town',
    'Sotik',
    'Kipsonoi',
    'Chepalungu',
    'Bomet East',
    'Bomet Central',
    'Bomet West',
    'Longisa',
    'Ndanai Bomet side',
    'Kembu',
    'Sigor',
    'Kapkoros',
    'Kabulasi',
    'Chemaner',
    'Merigi',
    'Kipreres',
    'Mogos',
    'Other',
  ],
  Narok: [
    'Narok Town',
    'Maasai Mara',
    'Ololulungua',
    'Kilgoris',
    'Ntulele',
    'Suswa',
    'Osupuko',
    'Enoosaen',
    'Loliondo',
    'Maji Moto',
    'Lemek',
    'Olchoro',
    'Nkoben',
    'Naremo',
    'Olpusimoru',
    'Mulot',
    'Sekenani',
    'Talek',
    'Siana',
    'Aitong',
    'Other',
  ],
  Laikipia: [
    'Nanyuki',
    'Nyahururu Laikipia side',
    'Rumuruti',
    'Doldol',
    'Timau Laikipia side',
    'Mukogodo',
    'Laikipia East',
    'Laikipia West',
    'Laikipia North',
    'Laikipia Central',
    'Ol Jogi',
    'Sosian',
    'Kinamba',
    'Ngarua',
    'Segera',
    'Kisima',
    'Mfangano Laikipia side',
    'Other',
  ],
  Isiolo: [
    'Isiolo Town',
    'Merti',
    'Garba Tula',
    'Kina',
    'Bulumuri',
    'Ngarua Isiolo side',
    'Archers Post',
    'Biasan',
    'Kurkum',
    'Olorupia',
    'Cherab',
    'Kinna',
    'Oldonyiro',
    'Malkagalla',
    'Other',
  ],
  Garissa: [
    'Garissa Town',
    'Dadaab',
    'Habaswein',
    'Sankuri',
    'Balambala',
    'Ijara',
    'Masalani',
    'Arids',
    'Modogashe',
    'Barwago',
    'Bura',
    'Jarajila',
    'Galma Dhere',
    'Kulan',
    'Alinjugur',
    'Shimbir Fatuma',
    'Other',
  ],
  Wajir: [
    'Wajir Town',
    'Habaswein Wajir side',
    'Tarbaj',
    'Griftu',
    'Buna',
    'Khorof Harar',
    'Gumarey',
    'Dajabula',
    'Eldas',
    'Ijara Wajir side',
    'Tulatula',
    'Bilad',
    'Bute',
    'Habaswein',
    'Kotulo',
    'Other',
  ],
  Mandera: [
    'Mandera Town',
    'Rhamu',
    'Takaba',
    'El Wak',
    'Banisa',
    'Fino',
    'Ashabito',
    'Debo',
    'Gither',
    'Lafey',
    'Kotulo',
    'Rhamu Dimtu',
    'Arabia',
    'Shimbir',
    'Malkamari',
    'Other',
  ],
  Marsabit: [
    'Marsabit Town',
    'Moyale',
    'Turbi',
    'North Horr',
    'Loiyangalani',
    'Saku',
    'Kargi',
    'Chalbi Desert',
    'Bubisa',
    'Dukana',
    'Maikona',
    'Kalacha',
    'Illeret',
    'Koburi',
    'Golbo',
    'Sololo',
    'Funo',
    'Bori',
    'Other',
  ],
  Turkana: [
    'Lodwar',
    'Lokichar',
    'Kakuma',
    'Lokitaung',
    'Turkwell',
    'Lorugum',
    'Kapedo',
    'Kainuk',
    'Lokori',
    'Lobolo',
    'Nakwamoru',
    'Katilu',
    'Kangiris',
    'Namakat',
    'Lokwakangole',
    'Kalepo',
    'Lokori',
    'Nakurio',
    'Other',
  ],
  'West Pokot': [
    'Kapenguria',
    'Kacheliba',
    'Kokwos',
    'Kasei',
    'Kongelai',
    'Sigor West Pokot side',
    'Masol',
    'Kosul',
    'Kodich',
    'Kiwawa',
    'Kipkomo',
    'Kiwir',
    'Lodwar',
    'Kaben',
    'Other',
  ],
  Samburu: [
    'Maralal',
    'Baragoi',
    'Wamba',
    'Nyiro',
    'South Horr',
    'Karare',
    'Lodokejek',
    'Archers Post Samburu side',
    'Marti',
    'Loiyangalani Samburu side',
    'Kalama',
    'Kirisia',
    'Ngilai',
    'Other',
  ],
  'Trans Nzoia': [
    'Kitale',
    'Kiminini',
    'Endebess',
    'Kwanza',
    'Saboti',
    'Sinyerere',
    'Matunda',
    'Kapkoi',
    'Wehoya',
    'Kakamega Road Kitale',
    'Lodwar Road',
    'Sikhendu',
    'Kaplamai',
    'Makutano',
    'Suwerwa',
    'Other',
  ],
  'Elgeyo-Marakwet': [
    'Iten',
    'Tambach',
    'Kapsowar',
    'Kipchilat',
    'Kabiemit',
    'Kessup',
    'Kamuagut',
    'Chepkorio',
    'Keiyo',
    'Marakwet',
    'Soy Elgeyo-Marakwet side',
    'Kimwarer',
    'Torongo',
    'Kaptich',
    'Other',
  ],
  Baringo: [
    'Kabarnet',
    'Nakuru Baringo side',
    'Mogotio',
    'Eldama Ravine',
    'Marigat',
    'Kipsaraman',
    'Barwessa',
    'Chemorongit',
    'Esageri',
    'Tangulbei',
    'Loruk',
    'Maji Mazuri',
    'Sacho',
    'Mumberes',
    'Tenges',
    'Lembus',
    'Other',
  ],
  'Taita-Taveta': [
    'Voi',
    'Wundanyi',
    'Mwatate',
    'Taveta',
    'Werugha',
    'Bura Taita-Taveta side',
    'Mbololo',
    'Kimunyu',
    'Kishushe',
    'Makwasinyi',
    'Mghogoni',
    'Sagalla',
    'Mackinnon Road',
    'Mghambonyi',
    'Maktau',
    'Mata Taita-Taveta side',
    'Other',
  ],
  'Tana River': [
    'Hola',
    'Garsen',
    'Kipini',
    'Mpeketoni',
    'Madogo',
    'Bura Tana River side',
    'Ngao',
    'Mbalambala',
    'Wenje',
    'Sala',
    'Ozi',
    'Chara',
    'Kone',
    'Minjila',
    'Other',
  ],
  Lamu: [
    'Lamu Town',
    'Shella',
    'Kipungani',
    'Mpeketoni Lamu side',
    'Hindi',
    'Mokowe',
    'Pate Island',
    'Manda Island',
    'Kiwayu',
    'Faza',
    'Siyu',
    'Mkunumbi',
    'Kizingitini',
    'Mtangawanda',
    'Other',
  ],
  Kitui: [
    'Kitui Town',
    'Mwingi',
    'Mutomo',
    'Kyuso',
    'Katulani',
    'Kisasi',
    'Nguni',
    'Ikutha',
    'Mulango',
    'Zombe',
    'Kyawango',
    'Tseikuru',
    'Mumoni',
    'Migwani',
    'Lumumba',
    'Nzya',
    'Nduumoni',
    'Kalawa',
    'Kanyangi',
    'Kwa Mbeu',
    'Other',
  ],
  Makueni: [
    'Wote',
    'Makueni Town',
    'Kibwezi',
    'Kathonzweni',
    'Mtito Andei',
    'Nunguni',
    'Tawa',
    'Kasikeu',
    'Kilala',
    'Kisau',
    'Mukaa',
    'Mbiuni Makueni side',
    'Kinyambu',
    'Ntha',
    'Kikima',
    'Kalawa Makueni side',
    'Emali',
    'Salama',
    'Other',
  ],
  'Tharaka-Nithi': [
    'Chuka',
    'Marimanti',
    'Gatunga',
    'Chogoria',
    'Kiang\'ombe',
    'Maragwa',
    'Nturukuma',
    'Kathwana',
    'Kanyei',
    'Mukiri',
    'Nkono',
    'Karingani',
    'Mitunguu Tharaka-Nithi side',
    'Magundu',
    'Other',
  ],
  Nyamira: [
    'Nyamira Town',
    'Ekerenyo Nyamira side',
    'Keroka Nyamira side',
    'Manga Nyamira side',
    'Nyansiongo',
    'Ragengni',
    'Rigoma',
    'Riana Nyamira side',
    'Kiabonyoru',
    'Kebirigo',
    'Kenyenya',
    'Bonyamatuta',
    'Gesima',
    'Kiongori',
    'Mochenwa',
    'Other',
  ],
};
export function getAreasForCounty(county) {
  return COUNTY_AREAS[county] || ['Central', 'Other'];
}

export function formatJobLocation(county, area) {
  const trimmedCounty = (county || '').trim();
  const trimmedArea = (area || '').trim();
  if (!trimmedCounty) return '';
  if (!trimmedArea || trimmedArea === 'Other') return trimmedCounty;
  return `${trimmedCounty} – ${trimmedArea}`;
}

export function parseJobLocation(location) {
  const value = (location || '').trim();
  if (!value) return { county: '', area: '' };

  const dashIndex = value.indexOf(' – ');
  if (dashIndex === -1) {
    return { county: value, area: '' };
  }

  return {
    county: value.slice(0, dashIndex).trim(),
    area: value.slice(dashIndex + 3).trim(),
  };
}
